module.exports = __webpack_public_path__ + "assets/img/wzt_info.8ed23785.png";